import type { LocalBackup } from './local-backup';
import { assertBackupSnapshotIsSafe } from './backup-file';

export interface BackupComparison { matched:number; missing:number; different:number; extra:number }

// Object key order is not meaningful; array order and all stored values are.
function canonical(value:unknown):string {
  if(Array.isArray(value))return `[${value.map(canonical).join(',')}]`;
  if(value && typeof value==='object')return `{${Object.keys(value).sort().map(key=>`${JSON.stringify(key)}:${canonical((value as Record<string,unknown>)[key])}`).join(',')}}`;
  return JSON.stringify(value);
}

/** Compare every backed-up local key and IndexedDB entry, including tombstones and outbox. */
export function compareBackups(copy:LocalBackup,current:LocalBackup):BackupComparison {
  assertBackupSnapshotIsSafe(copy);assertBackupSnapshotIsSafe(current);
  const result:BackupComparison={matched:0,missing:0,different:0,extra:0};
  function compare(saved:Map<string,unknown>, live:Map<string,unknown>) {
    for(const [id,value] of live) {
      if(!saved.has(id))result.missing++;
      else if(canonical(saved.get(id))===canonical(value))result.matched++;
      else result.different++;
    }
    for(const id of saved.keys())if(!live.has(id))result.extra++;
  }
  compare(new Map(Object.entries(copy.localStorage)),new Map(Object.entries(current.localStorage)));
  const names=new Set([...Object.keys(copy.databases),...Object.keys(current.databases)]);
  for(const name of names){
    const saved=copy.databases[name] ?? {},live=current.databases[name] ?? {};
    for(const store of new Set([...Object.keys(saved),...Object.keys(live)])) {
      const index=(entries:unknown[])=>new Map(entries.map(entry=>[(entry as {id:string}).id,entry]));
      compare(index(saved[store] ?? []),index(live[store] ?? []));
    }
  }
  return result;
}
